import { render, staticRenderFns } from "./HotelImages.vue?vue&type=template&id=f812d1a8&scoped=true&"
import script from "./HotelImages.vue?vue&type=script&lang=js&"
export * from "./HotelImages.vue?vue&type=script&lang=js&"
import style0 from "./HotelImages.vue?vue&type=style&index=0&id=f812d1a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f812d1a8",
  null
  
)

export default component.exports